import { render, staticRenderFns } from "./ManageCampaignSubjectLineBlacklist.vue?vue&type=template&id=42c7de23"
import script from "./ManageCampaignSubjectLineBlacklist.vue?vue&type=script&lang=js"
export * from "./ManageCampaignSubjectLineBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports